module.exports = __webpack_public_path__ + "static/media/nisse-idle.e6334226.png";


//////////////////
// WEBPACK FOOTER
// ./public/assets/nisse-idle.png
// module id = 42
// module chunks = 0